angular
  .module('data-ng-path-item')
  .constant('ActionBuilderDTD', {
    option: 'integer',
    value: '*'
  })
  .factory('ActionBuilder', function ActionBuilder(Interface, ActionBuilderDTD) {
    var actionValueTypeConversion = function actionValueTypeConversion(value) {
      var tmp;

      if (!(value != null) || value === '') {
        return 0;
      }

      tmp = parseInt(value, 10);
      if (!_.isNaN(tmp)) {
        return tmp;
      }

      tmp = value === 'true' ? true : value === 'false' ? false : undefined;

      if (_.isBoolean(tmp)) {
        return tmp;
      }

      return value + '';
    };

    return function ActionDTO(data) {
      Interface.implement(ActionBuilderDTD, data, this);
      this.value = actionValueTypeConversion.call(this, this.value);
    };
  });



// WEBPACK FOOTER //
// ./app/vendor/data-ng-path-item/src/builders/action_builder.js